import i18n from 'services/base/i18n';

export default {
  address: () => i18n.pgettext('Pages|List Issues|View Issue|Malware Address', 'Malware Address'),
  host:    () => i18n.pgettext('Pages|List Issues|View Issue|Malware Address', 'Affected Host'),
  family:  () => i18n.pgettext('Pages|List Issues|View Issue|Malware Address', 'Malware Family'),
  action:  () => i18n.pgettext('Pages|List Issues|View Issue|Malware Address', 'Enforced Action'),
};
